/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamLanguageDropdownQueryResponse,
  GetApiV1ExamLanguageDropdown401,
  GetApiV1ExamLanguageDropdown500,
} from "../../types/examSharedController/GetApiV1ExamLanguageDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamLanguageDropdown } from "../../clients/examSharedController/getApiV1ExamLanguageDropdown.ts";

export const getApiV1ExamLanguageDropdownQueryKey = () =>
  [{ url: "/api/v1/exam/language-dropdown" }] as const;

export type GetApiV1ExamLanguageDropdownQueryKey = ReturnType<
  typeof getApiV1ExamLanguageDropdownQueryKey
>;

export function getApiV1ExamLanguageDropdownQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamLanguageDropdownQueryKey();
  return queryOptions<
    GetApiV1ExamLanguageDropdownQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamLanguageDropdown401 | GetApiV1ExamLanguageDropdown500
    >,
    GetApiV1ExamLanguageDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamLanguageDropdown({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista de idiomas suportados para uso em componentes de seleção, com o código de cultura como chave e o nome do idioma em português como valor. **(Requer Authorization para autenticação)**
 * @summary Lista de idiomas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/language-dropdown}
 */
export function useGetApiV1ExamLanguageDropdown<
  TData = GetApiV1ExamLanguageDropdownQueryResponse,
  TQueryData = GetApiV1ExamLanguageDropdownQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamLanguageDropdownQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamLanguageDropdownQueryResponse,
        ResponseErrorConfig<
          GetApiV1ExamLanguageDropdown401 | GetApiV1ExamLanguageDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamLanguageDropdownQueryKey();

  const query = useQuery(
    {
      ...getApiV1ExamLanguageDropdownQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1ExamLanguageDropdown401 | GetApiV1ExamLanguageDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
